import React, { Component } from 'react';

import Table from './table';
import Navbar from '../../components/navBar/navBar';
import NoAccess from '../../components/NoAccess/NoAccess';
import { verifyLogin } from '../../helpers';
import PageContainer from '../../components/PageContainer/PageContainer';

class LoanTasks extends Component {
  constructor() {
    super();
    this.state = {
      permission: {},
      permissionLoaded: false,
    };
  }

  componentDidMount() {
    const { roleMapping, user } = verifyLogin();
    if (user.userRoleId === 1 || user.userRoleId === 2) {
      this.setState({
        permission: {
          view: true, add: true, edit: true, delete: true,
        },
      });
    } else {
      const permission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Loan Tasks');
      this.setState({ permission: permission || {} });
    }
    this.setState({ permissionLoaded: true });
  }

  render() {
    const { permission, permissionLoaded } = this.state;

    verifyLogin();
    return (
      <div className='ds-page'>

        <Navbar MainProps={this.props} />

        <PageContainer width='wide'>
          {permission.view
            ? <Table MainProps={this.props} MainState={this.state} />
            : <NoAccess permissionLoaded={permissionLoaded} what='loan tasks' />}
        </PageContainer>

      </div>
    );
  }
}

export default LoanTasks;
